import type { IssueEffort, IssueSeverity, IssueStatus } from "./core";
import type { Pillar } from "./metrics";

/**
 * Canonical human labels for stored enum values.
 *
 * These live in contracts, not in a frontend file, because the backend renders
 * them into customer-facing artifacts (the issue workbook) while the UI renders
 * them on screen — the same stored value must read as the same word in both, or
 * a spreadsheet and the dashboard disagree about the same issue. Wording chosen
 * for one surface's tone or layout is NOT this: that stays beside its surface.
 *
 * Every map is keyed by the union so a new enum member fails to compile here
 * rather than rendering as a blank or a raw snake_case value.
 */

export const ISSUE_SEVERITY_LABELS: Record<IssueSeverity, string> = {
  critical: "Critical",
  high: "High",
  medium: "Medium",
  low: "Low",
};

// `resolved` is the agent-verified terminal state and reads as "Verified fixed"
// everywhere. It is the reason a generic snake_case title-caser can never be
// correct for this enum.
export const ISSUE_STATUS_LABELS: Record<IssueStatus, string> = {
  open: "Open",
  in_progress: "In progress",
  done: "Done",
  ignored: "Ignored",
  resolved: "Verified fixed",
};

export const ISSUE_EFFORT_LABELS: Record<IssueEffort, string> = {
  S: "Small",
  M: "Medium",
  L: "Large",
};

export const PILLAR_LABELS: Record<Pillar, string> = {
  Performance: "Performance",
  Experience: "Experience",
  "AI Readiness": "AI Readiness",
  Discoverability: "Discoverability",
  "Content Fitness": "Content Fitness",
  "AI Reference": "AI Reference",
};
